module.exports = function(h, row) {
    return (
        moment(row.available_from)
            .format('DD MMM YYYY')
            .toUpperCase() +
        ' - ' +
        moment(row.available_to)
            .format('DD MMM YYYY')
            .toUpperCase()
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/available_from_date.jsx